import React, { useState } from "react";
import CardsItems from "./CardsItems";
import Box from "../../assests/Images/RingBox.png";
import GiftBags from "../../assests/Images/LuxuryGiftBags.png";
import WrappingPaper from "../../assests/Images/TISSUE.png";
import Stickers from "../../assests/Images/STICKERS.png";
import Receipt from "../../assests/Images/RECEIPTWALLET.png";
import { useLocation } from "react-router-dom";

function CardContainer({ props }) {
  const logo = useLocation()

  const articles = [
    {
      source: {
        id: 1,
        name: "Luxury Ring Box",
      },
      ImageUrl: Box,
      title: "Luxury Ring Box",
    },
    {
      source: {
        id: 2,
        name: "Luxury Gift Bags",
      },
      ImageUrl: GiftBags,
      title: "Luxury Gift Bags",
    },
    {
      source: {
        id: 3,
        name: "Tissue Paper",
      },
      ImageUrl: WrappingPaper,
      title: "Tissue Paper",
    },
    {
      source: {
        id: 4,
        name: "Stickers",
      },
      ImageUrl: Stickers,
      title: "Stickers",
    },
    {
      source: {
        id: 5,
        name: "Receipt Wallet",
      },
      ImageUrl: Receipt,
      title: "Receipt Wallet",
    },
    // {
    //   source: {
    //     id: 6,
    //     name: "Receipt Wallet",
    //   },
    //   ImageUrl: ReceiptOutside,
    //   title: "Receipt Wallet",
    // },
  ];

  return (
    <>
      <div className="flex flex-col justify-center text-center items-center mt-3 gap-2 w-[100%]">
        {/* <UploadLogoButton text={"UPLOAD YOUR STORE LOGO"} style={"gap-16"} btnID={"all"} /> */}
        {/* <p className="text-[13px] " style={{ fontFamily: "ZapfHumanistBold" }}>
          UPLOAD YOUR LOGO (we recommend a PNG file if you have one) and{" "}
        </p>
        <p className="text-[13px] " style={{ fontFamily: "ZapfHumanistBold" }}>
          CHOOSE ANY ITEM TO START (in any order you prefer)...
        </p> */}
      </div>
      <div className="w-[100%]">
        <div className="custom-class">
          {articles?.map((element, index) => (
            <div className="mt-10" key={index} onClick={() => {}}>
              {/* This is a card Component */}
              <CardsItems
                ID={element.source.id - 1}
                title={element.title}
                imageUrl={element.ImageUrl}
                logo={logo.state}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-center mt-10"></div>
    </>
  );
}

export default CardContainer;
